import { render, staticRenderFns } from "./WinnerSelection.vue?vue&type=template&id=83b7e442&scoped=true&"
import script from "./WinnerSelection.vue?vue&type=script&lang=js&"
export * from "./WinnerSelection.vue?vue&type=script&lang=js&"
import style0 from "./WinnerSelection.vue?vue&type=style&index=0&id=83b7e442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b7e442",
  null
  
)

export default component.exports